import React, { Component } from 'react';

import { Link } from 'react-router-dom';

import './Navigation.css';

export default class Navigation extends Component {
    constructor() {
        super();
        this.state = {};
        this.state.pageList = [
            { id: 0, pageName: 'My Portfolio', pageRoute: '/portfolio' },
            { id: 1, pageName: 'Quote', pageRoute: '/quote' },
            { id: 2, pageName: 'Apply Now', pageRoute: '/credit' }

            // {id: 2, pageName:"F.A.Q", pageRoute : "faq"},
            // {id: 3, pageName:"Contact", pageRoute : "contact"}
        ];
    }

    render() {
        return (
            <nav>
                <ul>
                    {this.state.pageList.map(page => (
                        <li key={page.id}>
                            <Link to={page.pageRoute} activeClassName="active">
                                {page.pageName}
                            </Link>
                        </li>
                    ))}
                    <li>
                        <a href="//canlease.net/contact-us/" target="_blank">
                            {' '}
                            Contact Us{' '}
                        </a>
                    </li>
                </ul>
            </nav>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/navigation/Navigation.jsx